import { toast } from "sonner";
import { PageHeader, DataTable, GhostButton } from "@/components/admin/ui";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg, formatDateTime } from "@/lib/api";

const tone = { sent: "text-emerald-700", failed: "text-rose-700", queued: "text-blue-700" };

export function EmailLogs() {
  const { data, loading } = useFetch("/admin/email-logs");
  return (
    <div data-testid="email-logs-page">
      <PageHeader eyebrow="Delivery" title="Email log" description="Every transactional email with delivery status. Failed sends are retried automatically up to 3 times." />
      <DataTable testId="email-logs-table" loading={loading} rows={data} columns={[
        { key: "to", label: "To" }, { key: "template", label: "Type", render: (r) => r.template.replace(/_/g, " ") },
        { key: "subject", label: "Subject", className: "max-w-xs" },
        { key: "status", label: "Status", render: (r) => <span className={`font-semibold ${tone[r.status]}`}>{r.status}</span> },
        { key: "attempts", label: "Attempts" }, { key: "created_at", label: "At", render: (r) => formatDateTime(r.created_at) },
      ]} />
    </div>
  );
}

export function Messages() {
  const { data, loading, reload } = useFetch("/admin/messages");
  const resolve = async (id) => { try { await api.post(`/admin/messages/${id}/resolve`); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="messages-page">
      <PageHeader eyebrow="Inbox" title="Contact messages" description="Messages from the Contact Us page. Each is also emailed to support@campussaarthi.com." />
      <DataTable testId="messages-table" loading={loading} rows={data} columns={[
        { key: "name", label: "From", render: (r) => <div><p className="font-semibold">{r.name}</p><p className="text-xs text-[#635060]">{r.email} {r.phone}</p></div> },
        { key: "message", label: "Message", className: "max-w-md", render: (r) => <p className="whitespace-pre-line text-[#3b2b38]">{r.message}</p> },
        { key: "created_at", label: "At", render: (r) => formatDateTime(r.created_at) },
        { key: "status", label: "", render: (r) => (r.status === "new" ? <GhostButton onClick={() => resolve(r.id)} data-testid={`resolve-message-${r.id}`}>Mark resolved</GhostButton> : <span className="text-emerald-700 text-xs font-semibold">Resolved</span>) },
      ]} />
    </div>
  );
}

export function AuditLog() {
  const { data, loading } = useFetch("/admin/audit-logs");
  return (
    <div data-testid="audit-log-page">
      <PageHeader eyebrow="Security" title="Audit log" description="Recent access and changes to student data, consents, payments and configuration." />
      <DataTable testId="audit-table" loading={loading} rows={data} columns={[
        { key: "created_at", label: "At", render: (r) => formatDateTime(r.created_at) },
        { key: "action", label: "Action", render: (r) => <span className="font-mono text-xs">{r.action}</span> },
        { key: "actor_role", label: "By", render: (r) => r.actor_role || "system" },
        { key: "target_type", label: "Target", render: (r) => `${r.target_type} ${r.target_id ? r.target_id.slice(0, 8) : ""}` },
      ]} />
    </div>
  );
}
